<template>
  <form class="search-area">
    <b-form-row>
      <b-col class="form-group">
        <h3 class="common__search-title">Tutor</h3>
        <input
          v-model="conditions.tutorNameOrId"
          type="text"
          class="form-control w-50"
        >
      </b-col>
      <b-col class="form-group">
        <h3 class="common__search-title">Position</h3>
        <PositionsInput v-model="conditions.positions"/>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col class="form-group">
        <h3 class="common__search-title">Gender</h3>
        <GendersInput v-model="conditions.genderCodes"/>
      </b-col>
      <b-col class="form-group">
        <h3 class="common__search-title">Include Past Tutors</h3>
          <div>
            <label class="checkbox">
              <input type="checkbox" v-model="conditions.isIncludeTerminationOfService">
            </label>
          </div>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col class="form-group">
        <h3 class="common__search-title">Nationality</h3>
        <NationalityInput
          v-model="conditions.nationality"
          class="form-control w-25"
        />
      </b-col>
    </b-form-row>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </form>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import PositionsInput from '@/components/parts/inputItem/PositionsInput.vue';
import GendersInput from '@/components/parts/inputItem/GendersInput.vue';
import NationalityInput from '@/components/parts/inputItem/NationalityInput.vue';
import _ from 'lodash';
import { Nationality, Position } from '@/store/master/types';
import { genderCode } from '@/store/common.types';

export interface TutorSearchConditions {
  tutorNameOrId: string|null
  positions: Position[]
  isIncludeTerminationOfService: boolean
  genderCodes: genderCode[]
  nationality: Nationality|null
}

@Component({
  components: {
    PositionsInput,
    GendersInput,
    NationalityInput,
  },
})
export default class TutorSearch extends Vue {
  private conditions: TutorSearchConditions = {
    tutorNameOrId: null,
    positions: [],
    isIncludeTerminationOfService: false,
    genderCodes: [],
    nationality: null,
  }

  search() {
    this.$emit('search', this.conditions)
  }

  reset() {
    this.conditions = {
      tutorNameOrId: null,
      positions: [],
      isIncludeTerminationOfService: false,
      genderCodes: [],
      nationality: null,
    }
    this.search()
  }
}
</script>
